<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="toct"><a href="#/xhtml/04_Introduction">Introduction</a></h2>
<h2 class="toct"><a href="#/xhtml/05_Chapter01">Chapter One<span class="space1">Leibstandarte SS Adolf Hitler (LSSAH)</span></a></h2>
<h2 class="toc"><a href="#/xhtml/06_Chapter02">Chapter Two<span class="space2">Joachim Peiper – Early life</span></a></h2>
<h2 class="toc"><span href="#/xhtml/07_Chapter03" title="Link target outside of Sample">Chapter Three<span class="space3">Peiper’s Killings – 1943</span></span></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter04" title="Link target outside of Sample">Chapter Four<span class="space4">Boves Massacre</span></span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter05" title="Link target outside of Sample">Chapter Five<span class="space5">The Ardenne Abbey Massacre</span></span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter06" title="Link target outside of Sample">Chapter Six<span class="space6">The Malmedy Massacres</span></span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter07" title="Link target outside of Sample">Chapter Seven<span class="space7">The Wereth Massacre</span></span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter08" title="Link target outside of Sample">Chapter Eight<span class="space8">Malmedy Massacre: Arrest, Trial and Conviction</span></span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter09" title="Link target outside of Sample">Chapter Nine<span class="space9">Peiper’s Interview: 7 September 1945</span></span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter10" title="Link target outside of Sample">Chapter Ten<span class="space10">Peiper’s Trial</span></span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter11" title="Link target outside of Sample">Chapter Eleven<span class="space11">Prosecution Witnesses</span></span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter12" title="Link target outside of Sample">Chapter Twelve<span class="space12">Letter from Landsberg</span></span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter13" title="Link target outside of Sample">Chapter Thirteen<span class="space13">Peiper’s Life After Release</span></span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter14" title="Link target outside of Sample">Chapter Fourteen<span class="space14">Peiper’s Death</span></span></h2>
<h2 class="toc"><span href="#/xhtml/19_Chapter15" title="Link target outside of Sample">Chapter Fifteen<span class="space15">US Senate Committee Hearing on Armed Services, 1949</span></span></h2>
<h2 class="toc"><span href="#/xhtml/20_Chapter16" title="Link target outside of Sample">Chapter Sixteen<span class="space16">What the Papers Said</span></span></h2>
<h2 class="toct"><span href="#/xhtml/21_Epilogue" title="Link target outside of Sample">Epilogue</span></h2>
<h2 class="toc"><span href="#/xhtml/22_Appendix" title="Link target outside of Sample">Appendix</span></h2>
<h2 class="toc"><span href="#/xhtml/23_Sources" title="Link target outside of Sample">Sources</span></h2>
<h2 class="toc"><span href="#/xhtml/24_Bibligraphy" title="Link target outside of Sample">Author Biography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?1d974fe8